<template>
  <div class="head">
    <div class="glide">
      <div class="glide__track" data-glide-el="track">
        <ul class="glide__slides">
          <li class="glide__slide">
            <header_slide
              title="This year's theme"
              description="An extraordinary people, belonging to an extraordinary church being built by the extraordinary Almighty God."
              image_path="/assets/img/h1.jpg"
              position="center"
            ></header_slide>
          </li>
          <li class="glide__slide">
            <header_slide
              title="Chrisco's Vision"
              description="To be a new testament pattern church"
              image_path="/assets/img/h2.jpg"
              position="top"
            ></header_slide>
          </li>
        </ul>
      </div>
      <div class="glide__arrows" data-glide-el="controls">
        <button class="glide__arrow glide__arrow--left" data-glide-dir="<">
          <img src="/assets/img/arrow.svg" width="18px" />
        </button>
        <button class="glide__arrow glide__arrow--right" data-glide-dir=">">
          <img src="/assets/img/arrow.svg" width="18px" style="transform: rotate(180deg)" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Glide from "@glidejs/glide";
import header_slide from "@/components/header_slide";

export default {
  name: "Header",
  components: {
    header_slide
  },
  mounted() {
    new Glide(".glide", {
      type: "carousel",
      autoplay: 5000,
      perView: 1,
      gap: 0
    }).mount();
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/css/variables.scss";

@media only screen and (max-width: 600px) {
  .glide__arrows {
    display: none;
  }
}

.glide__slides {
  margin-bottom: 0;
}
</style>